<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn icon small v-on="on" @click="mapShowClick">
          <v-icon :color="feature.maps.color">{{ feature.maps.icon }}</v-icon>
        </v-btn>
      </template>
      <span>{{ feature.maps.toolTip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { feature } from '@/use/Constants'

export default {
  name: 'MapIconExternal',
  props: {
    name: {
      type: String,
      default: null
    },
    street: {
      type: String,
      default: null
    },
    city: {
      type: String,
      default: null
    },
    state: {
      type: String,
      default: null
    },
    postCode: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const mapShowClick = () => {
      const baseMapUrl = 'http://maps.google.com/maps?q='
      const addrInfoTemplate = '{street},{city},{state},{postCode}'

      const addrInfoRaw = addrInfoTemplate
        .replace('{street}', props.street)
        .replace('{city}', props.city)
        .replace('{state}', props.state)
        .replace('{postCode}', props.postCode)
      const addrInfo = encodeURIComponent(addrInfoRaw)
      window.open(baseMapUrl + addrInfo, '_blank')
    }

    return { feature, mapShowClick }
  }
}
</script>

<style lang="scss" scoped></style>
